import { useEffect } from 'react';

export default function Terms() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black pt-32 pb-20 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Condiciones de Uso</h1>
                <div className="text-gray-300 space-y-6 leading-relaxed">

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">1. Aceptación de las Condiciones</h2>
                        <p>Al acceder y utilizar los servicios de TVSOLA, usted acepta estar sujeto a estas condiciones de uso. Si no acepta estas condiciones, no utilice nuestros servicios.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">2. Descripción del Servicio</h2>
                        <p>TVSOLA proporciona un servicio de acceso a transmisiones de IPTV. No somos propietarios de los contenidos difundidos y no alojamos ningún archivo en nuestros servidores. Actuamos como un intermediario técnico.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">3. Uso de la Cuenta</h2>
                        <p>Su suscripción es personal y no debe compartirse públicamente. El intercambio de cuentas más allá de los límites de su plan (número de pantallas) puede resultar en la suspensión de su acceso sin reembolso.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">4. Pagos y Renovaciones</h2>
                        <p>Los pagos se realizan en un solo pago por la duración elegida. No hay renovación automática, a menos que se indique explícitamente lo contrario. Los precios están sujetos a cambios en cualquier momento.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">5. Responsabilidad</h2>
                        <p>TVSOLA se esfuerza por brindar un servicio estable las 24 horas, los 7 días de la semana. Sin embargo, no podemos garantizar una disponibilidad ininterrumpida debido a la naturaleza técnica de internet. No somos responsables de las interrupciones debidas a su proveedor de servicios de internet.</p>
                    </section>
                </div>
            </div>
        </main>
    );
}
